module.exports = __webpack_public_path__ + "img/logo.ea4a26b6.png";